/** @import assets */

import Tires        from "../Assets/category-tires.jpg";

import Rims         from "../Assets/category-rims.jpg";

import Moto         from "../Assets/category-moto.jpg";

import Truck        from "../Assets/category-truck.jpg";

import Battery      from "../Assets/category-batteries.jpg";

import Montage      from "../Assets/category-montage.jpg";

import { buildCategoryPath } from "../Misc/Permalinks";

import {
    localizedPath,
    normalizeLanguage
} from "../Components/SEO/localizedMeta";

const 

categories = ( t, language ) => { const currentLanguage = normalizeLanguage ( language ),

    categoryRoute = ( productType, parameters ) => localizedPath ( `${ buildCategoryPath ( productType ) }/${ parameters }`, currentLanguage );

    return [

        {

            image: Tires,

            title: t ( "tyres" ),

            URI: categoryRoute ( "tire", "f=12&sort=ASC" )

        },

        {

            image: Rims,

            title: t ( "rims" ),

            URI: categoryRoute ( "rim", "f=12&sort=ASC" )

        },

        {

            image: Moto,

            title: t ( "moto" ),

            URI: categoryRoute ( "tire", "f=12&vt=moto&sort=ASC" )

        },

        {

            image: Truck,

            title: t ( "truck" ),

            URI: categoryRoute ( "tire", "f=12&vt=truck&sort=ASC" )

        },

        {

            image: Battery,

            title: t ( "batteries" ),

            URI: categoryRoute ( "battery", "f=12&sort=ASC" )

        },

        {

            image: Montage,

            title: t ( "montage" ),

            URI: "/content/montage"

        }

    ];

}

/** @exports */

export {

    categories

}